'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var FiltroBuscarService = function () {
    function FiltroBuscarService($http, filtroBuscarFactory) {
        _classCallCheck(this, FiltroBuscarService);

        this.$http = $http;
        this.filtroBuscarFactory = filtroBuscarFactory;
    }

    _createClass(FiltroBuscarService, [{
        key: 'obtenerFiltro',
        value: function obtenerFiltro() {

            return this.filtroBuscarFactory.obtenerFiltro();
        }
    }, {
        key: 'buscar',
        value: function buscar(params, success, error) {
            this.filtroBuscarFactory.guardarFiltro(params);

            this.$http.get('api/documentos-buscar/', {
                params: params
            }).then(function (response) {
                success(response);
            }, function (response) {
                error(response);
            });
        }

        // aqui tienes un path distinto ... debes fijarte en esas cosas 

    }, {
        key: 'sugerir',
        value: function sugerir(params, success, error) {

            return this.$http.get('buscador/api/documentos-buscar/sugerencia', {
                params: params
            }).then(function (response) {
                return response.data.datos.map(function (item) {

                    return item;
                });
            }, function (response) {
                error(response);
            });
        }
    }, {
        key: 'recargar',
        value: function recargar(params, success, error) {
            this.$http.get('buscador/api/documentos-buscar/recarga', {
                params: params
            }).then(function (response) {
                success(response);
            }, function (response) {
                error(response);
            });
        }
    }, {
        key: 'exportar',
        value: function exportar(params, success, error) {

            this.$http.get('api/documentos-buscar/exportacion', {
                params: params
            }).then(function (response) {
                success(response);
            }, function (response) {
                error(response);
            });
        }
    }, {
        key: 'recargar',
        value: function recargar(params, success, error) {
            this.$http.get('api/documentos-buscar/recarga', {
                params: params
            }).then(function (response) {
                success(response);
            }, function (response) {
                error(response);
            });
        }
    }, {
        key: 'crear',
        value: function crear(params, success, error) {
            this.$http.post('api/documentos-buscar/creacion', params).then(function (response) {
                success(response);
            }, function (response) {
                error(response);
            });
        }
    }]);

    return FiltroBuscarService;
}();

FiltroBuscarService.$inject = ['$http', 'filtroBuscarFactory'];

exports.default = FiltroBuscarService;


// WEBPACK FOOTER //
// ./src/busqueda/servicios/buscador.service.js